import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Error404 from './Pages/404';
import Login from './Auth/Login';
import Register from './Auth/Register';
import ForgotPasswordPage from './Auth/ForgotPassword';
import DownloadItem from './Pages/DownloadItem';
import Movies from './Pages/Bundle';
import CreateMovies from './Pages/Bundle/CreateMovies';
import DownloadType from './Pages/Bundle/MovieList/DowloadType';
import CreateDownload from './Pages/Bundle/CreateDownload';
import ManageBundle from './Pages/Bundle/ManageBundle';
import Relations from './Pages/RelationManager';
import CreateRelation from './Pages/RelationManager/CreateRelation';
import Critics from './Pages/CriticsManagement';
import ShortCritic from './Pages/CriticsManagement/CreateShortCritic';
import NewsManagement from './Pages/NewsManager/NewsManagement';
import FinanceManagment from './Pages/FinanceManagment';
import CreatePayeoff from './Pages/FinanceManagment/CreatePayeoff';
import ArtistsManagement from './Pages/ArtistsManagement/ArtistsManagement';
import UploadMovieWrapper from './Pages/ConvertMovies/UploadMovie';
import ConvertableList from './Pages/ConvertMovies/ConvertableList';
import ConvertDetailsWrapper from './Pages/ConvertMovies/ConvertDetails';
import CreateRootMovie from './Pages/Bundle/CreateRootMovie';
import NewsList from './Pages/NewsManager/NewsItemList';

const movieManagerAccessRoutes = {
  "/download-item": "/download-item",
  "/movie": "/movie",
  "/create-movie": "/create-movie",
  "/create-download": "/create-download",
  "/manage-bundle": "/manage-bundle",
  "/edit-download-type": "/edit-download-type",
  "/relation-managment": "/relation-managment",
  "/create-relation": "/create-relation",
  "/create-root-movie": "/create-root-movie"
}

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  return (
    <Route
      {...rest}
      render={props =>
        authUser ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  const location = useLocation();

  if (location.pathname === '' || location.pathname === '/') {
    return <Redirect to={'/movie'} />;
  } else if (authUser && location.pathname === '/signin') {
    return <Redirect to={'/movie'} />;
  } else if (authUser && authUser?.permissions?.movies && location.pathname !== movieManagerAccessRoutes[location.pathname]) {
    return <Redirect to={'/movie'} />;
  }

  return (
    <React.Fragment>
      <Switch>
        <RestrictedRoute path="/download-item" component={DownloadItem} />
        <RestrictedRoute path="/movie" component={Movies} />
        <RestrictedRoute path="/content" component={Movies} />
        <RestrictedRoute path="/news-management" component={NewsManagement} />
        <RestrictedRoute path="/news" component={NewsList} />
        <RestrictedRoute path="/finance" component={FinanceManagment} />
        <RestrictedRoute path="/manage-payeoff" component={CreatePayeoff} />
        <RestrictedRoute path="/short-critic" component={Critics} />
        <RestrictedRoute path="/create-short-critic" component={ShortCritic} />
        <RestrictedRoute path="/create-movie" component={CreateMovies} />
        <RestrictedRoute path="/create-download" component={CreateDownload} />
        <RestrictedRoute path="/manage-bundle" component={ManageBundle} />
        <RestrictedRoute path="/manage-artist" component={ArtistsManagement} />
        <RestrictedRoute path="/edit-download-type" component={DownloadType} />
        <RestrictedRoute path="/relation-managment" component={Relations} />
        <RestrictedRoute path="/create-relation" component={CreateRelation} />
        <RestrictedRoute path="/create-root-movie" component={CreateRootMovie} />
        <RestrictedRoute path="/convert" component={UploadMovieWrapper} />
        <RestrictedRoute path="/convert-details" component={ConvertDetailsWrapper} />
        <RestrictedRoute path="/convert-list" component={ConvertableList} />
        <Route path="/signin" component={Login} />
        <Route path="/signup" component={Register} />
        <Route path="/forgot-password" component={ForgotPasswordPage} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
